import { assetTypesColors } from "@features/assets-feature/utils/assetsColors";
import { CACHE_KEY_ASSET_HARDWARE_BY_AGE } from "@features/assets-feature/constants";
import { PurchasedAssetsHardwareByAgeWidgetClient } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import { useQuery } from "@tanstack/react-query";

export const usePurchasedAssetsHardwareByAge = () => {
  const api = useApi(PurchasedAssetsHardwareByAgeWidgetClient);
  const {
    data: response,
    isLoading,
    error,
  } = useQuery({
    queryKey: CACHE_KEY_ASSET_HARDWARE_BY_AGE,
    queryFn: () => api.getHardwareByAge(),
    retry: false,
    refetchOnWindowFocus: false,
  });
  const dataPoints =
    response?.data?.yearlyHardwareCounts?.map((entry) => ({
      key: String(entry.year ?? ""),
      value: entry.count ?? 0,
    })) ?? [];
  const rawData = [
    {
      label: "Purchased",
      data: dataPoints,
      backgroundColor: assetTypesColors.hardware,
    },
  ];
  const data = {
    labels: [],
    datasets: rawData,
  };
  const isEmptyDataSet = !!response?.isEmptyDataSet;
  return { data, isLoading, error, isEmptyDataSet };
};
